import React, { useContext } from 'react';
import {
  Icon, Button, InputField, HorizontalSeparator,
} from 'anf-core-react';
import BreakpointContext from '../../contexts/BreakpointContext';
import ProductPageContext from '../../contexts/ProductPageContext';

export default function SearchStoresControls({
  onClick,
  setSearchedAddress,
  searchedAddress,
  loading,
}) {
  const breakpoints = useContext(BreakpointContext);
  const ProductPageState = useContext(ProductPageContext);
  const { tmntData } = ProductPageState;

  return (
    <div className="actions-container">
      <Button variant="secondary" classList="near-me-button">
        <Icon icon="location-anf" />
        {tmntData?.nearMe?.value}
      </Button>
      {!breakpoints.small ? (
        <HorizontalSeparator>
          {tmntData?.or?.value}
        </HorizontalSeparator>
      ) : <div className="vertical-separator" />}
      <div className="search-container">
        <InputField
          id="search-field"
          data-testid="search-field"
          label={tmntData?.cityStateZip?.value}
          name={tmntData?.cityStateZip?.value}
          value={searchedAddress}
          onChange={(e) => { setSearchedAddress(e.target.value); }}
          autoComplete="off"
        />
        <Button variant="secondary" classList="search-btn" isProcessing={loading} labelText="search" onClick={onClick}>
          {!loading && <Icon icon="search-anf" labelText="search" />}
        </Button>
      </div>
    </div>
  );
}
